import * as FullStory from '@fullstory/browser';
import * as Sentry from '@sentry/browser';
import SentryFullStory from '@sentry/fullstory';
import initialiseTracking from './tracking_cookies';

window.sentryFsIntegration = SentryFullStory;
window.Sentry = Sentry;
window.E1FS = FullStory;
window.initialiseTracking = initialiseTracking;
